"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAmenityDto = instanceOfAmenityDto;
exports.AmenityDtoFromJSON = AmenityDtoFromJSON;
exports.AmenityDtoFromJSONTyped = AmenityDtoFromJSONTyped;
exports.AmenityDtoToJSON = AmenityDtoToJSON;
exports.AmenityDtoToJSONTyped = AmenityDtoToJSONTyped;
/**
 * Check if a given object implements the AmenityDto interface.
 */
function instanceOfAmenityDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('icon' in value) || value['icon'] === undefined)
        return false;
    if (!('groupName' in value) || value['groupName'] === undefined)
        return false;
    return true;
}
function AmenityDtoFromJSON(json) {
    return AmenityDtoFromJSONTyped(json, false);
}
function AmenityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'icon': json['icon'],
        'groupName': json['groupName'],
    };
}
function AmenityDtoToJSON(json) {
    return AmenityDtoToJSONTyped(json, false);
}
function AmenityDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'icon': value['icon'],
        'groupName': value['groupName'],
    };
}
